import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["depth", "children", "enableOverflow", "classes", "flex"];
import React from 'react';
import classNames from 'classnames/bind';
import styles from './Depth.css';
var cx = classNames.bind(styles);
var defaultClasses = {};

var Depth = function Depth(props) {
  var _cx;

  var depth = props.depth,
      children = props.children,
      enableOverflow = props.enableOverflow,
      _props$classes = props.classes,
      classes = _props$classes === void 0 ? defaultClasses : _props$classes,
      flex = props.flex,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root', (_cx = {}, _defineProperty(_cx, "depth_".concat(depth), depth), _defineProperty(_cx, "enable_overflow", enableOverflow), _defineProperty(_cx, "flex", flex), _cx), classes.root)
  }, rest), children);
};

export default Depth;